import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

export default function TermsOfUse() {
  return (
    <>
      <SEO  
        title="Terms of Use - Legal Agreement | EnteliPro AI ERP & CRM"
        description="Read EnteliPro's Terms of Use to understand the legal agreement governing your use of our AI ERP and CRM software services and websites."
        keywords="Terms of Use, Legal Agreement, Terms and Conditions, EnteliPro Terms, ERP Terms, CRM Terms, Software Service Agreement"
        canonical="https://www.entelipro.com/termsofuse"
        ogImage="https://www.entelipro.com/static/media/logo512.png"
      />

      <Navbar />

      {/* Hidden H1 for SEO - visible to search engines but hidden visually */}  
      <h1 className="visually-hidden">Terms of Use - EnteliPro AI ERP & CRM Legal Agreement</h1>  

      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">  
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Terms of Use</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Terms of Use</h3>
              <p className="para">
                Welcome to {`${project_name}`}. We are glad you are here, and we
                hope you enjoy everything we have to offer. Please read these
                Terms carefully because they are a binding agreement between you
                and entelipro.com. These Terms govern your use of the websites
                that link to these Terms. In these Terms, the websites refer to
                each of these websites and the services offered on those sites.
                You automatically agree to these Terms and our Privacy Statement
                simply by using or logging into the sites.
              </p>
              <br />

              <p className="para">
                Please note that we offer many services. Your use of{" "}
                {`${project_name}`} products or services is provided by{" "}
                {`${project_name}`} under a separate manually or
                digitally-executed agreement. Those additional terms become part
                of your agreement with us if you use the services or log into
                the sites.
              </p>
              <br />
              <br />

              <h3>i. Your Accounts</h3>
              <p className="para">
                You may be required to create an account and specify a password
                to use certain services or features on the sites. To create an
                account, you must be at least 18 years old and you must provide
                truthful and accurate information about yourself. Don't try to
                impersonate anyone else when you create your account. If your
                information changes at any time, please update your account to
                reflect those changes.
              </p>
              <br />

              <p className="para">
                In some cases, an account may be assigned to you by an
                administrator, such as your employer or educational institution.
                If you are using or logging into an account assigned to you by
                an administrator, additional terms may apply to your use of the
                sites. Moreover, your administrator may be able to access or
                disable your account without our involvement.
              </p>
              <br />

              <p className="para">
                You may not share your account with anyone else. Please keep
                your password confidential, and try not to use it on other
                websites. If you believe that your account has been compromised
                at any time, please notify your system administrator.
              </p>
              <br />

              <br />
              <br />

              <h3>ii. Modifications and Termination</h3>
              <p className="para">
                We reserve the right to modify our sites at any time, with or
                without notice to you. For example, we may add or remove
                functionality or features, and we may suspend or stop a
                particular feature altogether. We also reserve the right to
                charge a fee for any of our features at any time. If you don't
                like any changes, you can stop using our sites at any time.
              </p>
              <br />
              <br />

              <h3>iii. Content You Post</h3>
              <p className="para">
                We may provide opportunities for you to post text, photographs,
                videos, or other content (collectively Content) on the sites.
                You can only post Content if you own all the rights to that
                Content, or if another rights holder has permitted you.
              </p>
              <br />

              <p className="para">
                You do not transfer ownership of your Content simply by posting
                it. However, by posting Content, you grant us, our agents,
                licensees, and assigns an irrevocable, perpetual (non-exclusive)
                right and permission to reproduce, encode, store, copy,
                transmit, publish, post, broadcast, display, publicly perform,
                adapt, modify, create derivative works of, exhibit, and
                otherwise use your Content. Without those rights, we couldn't
                offer our services. Please note that this license continues even
                if you stop using our sites.
              </p>
              <br />

              <p className="para">
                You agree to indemnify, release, and hold us harmless from all
                liability, claims, actions, loss, harm, damage, injury, cost, or
                expense arising out of any Content you post. Keep in mind that
                if you send us any information, ideas, suggestions, or other
                communications to us, those communications will not be
                confidential. Moreover, unless we tell you otherwise, we reserve
                the right to reproduce, use, disclose, and distribute such
                communications without any obligation to you.
              </p>
              <br />
              <br />

              <h3>iv. Content Posted by Others</h3>
              <p className="para">
                We are not responsible for and do not endorse, Content posted by
                any other person. Accordingly, we may not be held liable,
                directly or indirectly, for any loss or damage caused to you in
                connection with any content posted by another member.
              </p>
              <br />
              <br />

              <h3>v. Social Networks</h3>
              <p className="para">
                The Service may include features that operate in conjunction
                with certain third party social networking websites that you
                visit such as Facebook, Instagram, YouTube, and Twitter (Social
                Network Features). While your use of the Social Network Features
                is governed by these Terms, your access and use of third party
                social networking sites and the services provided through the
                services is governed by the terms of service and other
                agreements posted on these sites. You are responsible for
                ensuring that your use of those sites complies with any
                applicable terms of service or other agreements.
              </p>
              <br />
              <br />

              <h3>vi. Usage Limits for {`${project_name}`}</h3>
              <p className="para">
                {`${project_name}`} may prescribe usage limits based on the
                subscription plan chosen by You. You must make sure that your
                usage is within the usage limits prescribed by{" "}
                {`${project_name}`} in order to avail uninterrupted service. You
                understand that {`${project_name}`} may restrict an activity if
                you reach the usage limit corresponding to such activity.
              </p>
              <br />
              <br />

              <h3>vii. Indemnification</h3>
              <p className="para">
                You agree to defend, indemnify and hold harmless the{" "}
                {`${project_name}`}, its affiliates and their respective
                directors, officers, employees and agents from and against all
                claims and expenses, including attorneys fees, arising out of
                the use of the Websites by you. The {`${project_name}`} reserves
                the right to take over the exclusive defense of any claim for
                which we are entitled to indemnification under this section. In
                such event, you shall provide {`${project_name}`} with such
                cooperation as is reasonably requested by the{" "}
                {`${project_name}`}.
              </p>
              <br />
              <br />

              <h3>viii. Termination</h3>
              <p className="para">
                We are not responsible for, and do not endorse, Content posted
                by any other person. Accordingly, we may not be held liable,
                directly or indirectly, for any loss or damage caused to you in
                connection with any content posted by another member.
              </p>
              <br />
              <br />

              <h3>ix. Use of Services</h3>
              <p className="para">
                The services may contain e-mail services, bulletin board
                services, chat areas, news groups, forums, communities, personal
                web pages, calendars, photo albums, file cabinets, and/or other
                message or communication facilities designed to enable you to
                communicate with others (each a "Communication Service" and
                collectively "Communication Services"). <br />
                You agree to use the Communication Services only to post, send
                and receive messages and material that are proper and, when
                applicable, related to the particular Communication Service. By
                way of example, and not as a limitation, you agree that when
                using the Communication Services, you will not :
              </p>
              <br />

              <p className="para">
                1. Use the Communication Services in connection with surveys,
                contests, pyramid schemes, chain letters, junk email, spamming,
                or any duplicative or unsolicited messages (commercial or
                otherwise).
                <br />
                <br />
                2. Defame, abuse, harass, stalk, threaten, or otherwise violate
                the legal rights (such as rights of privacy and publicity) of
                others.
                <br />
                <br />
                3. Publish, post, upload, distribute or disseminate any
                inappropriate, profane, defamatory, obscene, indecent, or
                unlawful topic, name, material, or information.
                <br />
                <br />
                4. Upload, or otherwise make available, files that contain
                images, photographs, software, or other material protected by
                intellectual property laws, including, by way of example, and
                not as a limitation, copyright or trademark laws (or by rights
                of privacy of publicity) unless you own or control the rights
                thereto or have received all necessary consent to do the same.
                <br />
                <br />
                5. Use any material or information, including images or
                photographs, which are made available through the services in
                any manner that infringes any copyright, trademark, patent,
                trade secret, or another proprietary right of any party.
                <br />
                <br />
                6. Upload files that contain viruses, Trojan horses, worms, time
                bombs, cancelbots, corrupted files, or any other similar
                software or programs that may damage the operation of another's
                computer or property of another.
                <br />
                <br />
                7. Advertise or offer to sell or buy any goods or services for
                any business purpose, unless such Communication Services
                specifically allow such messages.
              </p>
              <br />
              <br />

              <h3>x. No Unlawful or Prohibited Use</h3>
              <p className="para">
                As a condition of your use of the services, you will not use the
                services for any purpose that is unlawful or prohibited by these
                terms, conditions, and notices. You may not use the services in
                any manner that could damage, disable, overburden, or impair any{" "}
                {`${project_name}`} server, or the networks connected to any{" "}
                {`${project_name}`} server, or interfere with any other party's
                use and enjoyment of any services. You may not attempt to gain
                unauthorized access to any services, other accounts, computer
                systems, or networks connected to any {`${project_name}`} server
                or any of the services, through hacking, password mining, or any
                other means. You may not obtain or attempt to obtain any
                materials or information through any means not intentionally
                made available through the services.
              </p>
              <br />
              <br />

              <h3>xi. English Version Controls</h3>
              <p className="para">
                Non-English translations of this Policy are provided for
                convenience only. In the event of any ambiguity or conflict
                between translations, the English version is authoritative and
                controlled.
              </p>
              <br />
              <br />

              <h3>xii. Governing Law</h3>
              <p className="para">
                The content, data, video, and all other material and features on
                the Websites are presented to provide entertainment, news and/or
                information and/or promote programs, films, music, games, and
                other products and/or services that are or may become available
                in India, its territories, possessions, and protectorates.
              </p>
              <br />
              <p className="para">
                Any disputes, claims, and controversies arising out of or in
                connection with your access to, or use of the Website.
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}